import React from "react"
import {Box, Typography} from "@mui/material"

// React-Error-Boundaries gibt es nur als Klasse (kein Hook-Aequivalent fuer
// getDerivedStateFromError/componentDidCatch). Faengt Render-Fehler im
// Inhaltsbereich ab, damit ein einzelner kaputter Container nicht die ganze
// App weiss macht. Reset bei Routenwechsel via resetKey.
class RouteErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = {hasError: false, key: props.resetKey}
    }

    static getDerivedStateFromProps(props, state) {
        if (props.resetKey !== state.key) {
            return {hasError: false, key: props.resetKey}
        }
        return null
    }

    static getDerivedStateFromError() {
        return {hasError: true}
    }

    componentDidCatch(error, info) {
        console.error("[App] Fehler beim Rendern des Inhaltsbereichs", error, info)
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box sx={{p: 4}}>
                    <Typography variant="h6">
                        Im Inhaltsbereich ist ein Fehler aufgetreten.
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary">
                        Details siehe Browser-Konsole.
                    </Typography>
                </Box>
            )
        }
        return this.props.children
    }
}

export default RouteErrorBoundary
